<div class="modal-dialog modal-dialog-centered detail-modal">
    <div class="modal-content">
        <div class="modal-header mt-0">
            <h4 class="modal-title">Customer Volumetric </h4>
            <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="card" >
                <div class="card-body">
                <form [formGroup]="volumetricForm" >
                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="product" class="form-label">Product<span class="mandatory">*</span></label>
                                <ng-select id="product" formControlName="ddlProduct" placeholder="Select"
                                    [items]="productList" bindLabel="name" [bindValue]="'id'" 
                                    [ngClass]="{ 'is-invalid': (isFormSubmitted || volumetricForm.get('ddlProduct')?.touched) && volumetricForm.get('ddlProduct')?.errors }"/>
                                    <div *ngIf="(isFormSubmitted || volumetricForm.get('ddlProduct')?.touched) && volumetricForm.get('ddlProduct')?.errors"
                                    class="invalid-feedback">
                                    <span *ngIf="volumetricForm.get('ddlProduct')?.errors?.required">
                                        Product is required.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="formVendor" class="form-label">Vendor<span class="mandatory">*</span></label>
                                <ng-select id="formVendor" formControlName="ddlVendor" placeholder="Select"
                                    [items]="vendorList" bindLabel="name" [bindValue]="'id'"
                                    (change)="getAllVendorServices($event.id, true)" 
                                    [ngClass]="{ 'is-invalid': (isFormSubmitted || volumetricForm.get('ddlVendor')?.touched) && volumetricForm.get('ddlVendor')?.errors }"/>
                                    <div *ngIf="(isFormSubmitted || volumetricForm.get('ddlVendor')?.touched) && volumetricForm.get('ddlVendor')?.errors"
                                    class="invalid-feedback">
                                    <span *ngIf="volumetricForm.get('ddlVendor')?.errors?.required">
                                        Vendor is required.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="service" class="form-label">Service<span class="mandatory">*</span></label>
                                <ng-select id="service" formControlName="ddlService" placeholder="Select"
                                    [items]="serviceList" bindLabel="servicename" [bindValue]="'id'" 
                                    [ngClass]="{ 'is-invalid': (isFormSubmitted || volumetricForm.get('ddlService')?.touched) && volumetricForm.get('ddlService')?.errors }"/>
                                    <div *ngIf="(isFormSubmitted || volumetricForm.get('ddlService')?.touched) && volumetricForm.get('ddlService')?.errors"
                                    class="invalid-feedback">
                                    <span *ngIf="volumetricForm.get('ddlService')?.errors?.required">
                                        Service is required.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-1">
                                <label for="name" class="form-label">CFT <span class="mandatory">*</span></label>
                                <input type="text" class="form-control form-control-sm" id="name" formControlName="txtcft" maxlength="50" 
                                    [ngClass]="{ 'is-invalid': (isFormSubmitted || volumetricForm.get('txtcft')?.touched) && volumetricForm.get('txtcft')?.errors }">
                                <div *ngIf="(isFormSubmitted || volumetricForm.get('txtcft')?.touched) && volumetricForm.get('txtcft')?.errors"
                                    class="invalid-feedback">
                                    <span *ngIf="volumetricForm.get('txtcft')?.errors?.required">
                                        CFT is required.
                                    </span>
                                    <span *ngIf="volumetricForm.get('txtcft')?.errors?.pattern">
                                        Only up to 10 digits allowed and up to 2 decimal places.
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-md-6">
                            <div class="mb-2">
                                <label class="form-label">Volumetric Divisor</label>
                                <div class="input-group mb-2">
                                    <span for="centimeter" class="input-group-text group-label-sm">Centimeter</span>
                                    <input type="number" class="form-control form-control-sm" id="centimeter" maxlength="50" formControlName="txtCentimeter"
                                        [ngClass]="{ 'is-invalid': (isFormSubmitted || volumetricForm.get('txtCentimeter')?.touched) && volumetricForm.get('txtCentimeter')?.errors}">
                                    <div *ngIf="(isFormSubmitted || volumetricForm.get('txtCentimeter')?.touched) && volumetricForm.get('txtCentimeter')?.errors"
                                        class="invalid-feedback">
                                        <span *ngIf="volumetricForm.get('txtCentimeter')?.errors?.required">
                                            Centimeter is required.
                                        </span>
                                        <span *ngIf="volumetricForm.get('txtCentimeter')?.errors?.pattern">
                                            Enter a valid value (up to 8 digits and 2 decimal places).
                                        </span>
                                    </div>
                                    <span for="inches" class="input-group-text group-label-sm">Inches</span>
                                    <input type="number" class="form-control form-control-sm" id="inches" formControlName="txtInches" maxlength="50"
                                        [ngClass]="{ 'is-invalid': (isFormSubmitted || volumetricForm.get('txtInches')?.touched) && volumetricForm.get('txtInches')?.errors }">
                                    <div *ngIf="(isFormSubmitted || volumetricForm.get('txtInches')?.touched) && volumetricForm.get('txtInches')?.errors"
                                        class="invalid-feedback">
                                        <span *ngIf="volumetricForm.get('txtInches')?.errors?.required">
                                            Inches is required.
                                        </span>
                                        <span *ngIf="volumetricForm.get('txtInches')?.errors?.pattern">
                                            Enter a valid value (up to 8 digits and 2 decimal places).
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 mt-3">
                            <div class="mb-2 mt-1">
                                <div *ngIf="!isUpdate">
                                    <button type="button" class="btn btn-primary btn-sm" (click)="Add()">
                                        <i class="mdi mdi-plus"></i>
                                        Add
                                    </button>
                                </div>
                                <div *ngIf="isUpdate">
                                    <button type="button" class="btn btn-primary btn-sm" (click)="Update()">
                                        Update
                                    </button>
                                    <button type="button" class="btn btn-secondary btn-sm" (click)="resetForm()">
                                        Cancel 
                                    </button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 grid-container">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                            [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                            [enableCellTextSelection]="true" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
                            [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReady($event)">
                            </ag-grid-angular>
                        </div>
                    </div>
                </form>
            </div>
          </div>
        </div>
    </div>